import React from 'react';
import { Form, FormGroup, FormControl, Button, Modal, Container, Row, Col } from 'react-bootstrap';
import { CustomDatePicker } from '../../_components';
import config from '../../../config';
import moment from 'moment';
import { canAccessPlanningModule, isPlanner } from '../../utils/roleConstants';
import {
    Scheduler,
    SchedulerData,
    ViewType,
    CellUnit,
    DATE_FORMAT,
} from 'react-big-schedule';
import 'react-big-schedule/dist/css/style.css';
import DemoData from './DemoData';
import withDragDropContext from './withDnDContext';
import '../../Assets/style.css';
import { HexColorPicker } from "react-colorful";
import { Autocomplete, TextField } from '@mui/material';
import ReactToPrint from 'react-to-print';
import utils from '../../utils';
import DataTable from 'react-data-table-component';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';
import {
    calcCompleteTimeHours,
    calcRemainingTimeHours,
    countPlanningWorkingHours,
    formatPlanningEndDate,
    formatPlanningStartDate,
    isPlanningWorkingMoment,
    productionHoursFromCompleteTime,
} from './planningSchedule';


let schedulerData;
// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value, list = []) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(lang =>
        (lang.partNo || '').toLowerCase().slice(0, inputLength) === inputValue
    );
};

const getJobSuggestions = (value, list = []) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(lang =>
        (lang.jobNo || '').toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
};

const getToolingSuggestions = (value, list = []) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(item =>
        (item.toolingNo || '').toLowerCase().slice(0, inputLength) === inputValue
    );
};

const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
};
const resources = [
    {
        id: '1',
        name: '',
    },
    {
        id: '2',
        name: 'Manpower',
        groupOnly: true,

    }
];

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
    <div>
        {suggestion.partNo}
    </div>
);

const renderJobSuggestion = suggestion => (
    <div>
        {suggestion.jobNo}
    </div>
);

const renderToolingSuggestion = suggestion => (
    <div>
        {suggestion.toolingNo}
    </div>
);

class Planning extends React.Component {
    _isMounted = false;
    _currentJobNo = ''; // Synchronously tracked jobNo to avoid async setState race conditions
    constructor(props) {
        super(props);
        schedulerData = new SchedulerData(new moment().format(DATE_FORMAT), ViewType.Custom1, false, false,
            {
                schedulerWidth: '80%',
                nonAgendaDayCellHeaderFormat: 'M/D|HH:mm',
                resourceName: '',
                //customResourceTableWidth: '0',
                customCellWidth: '18%',
                nonWorkingTimeHeadColor: '#888888',
                nonWorkingTimeHeadBgColor: '#e8e8e8',
                nonWorkingTimeBodyBgColor: '#f0f0f0',
                views: [
                    { viewName: 'Two weeks', viewType: ViewType.Custom1, showAgenda: false, isEventPerspective: false },
                ],
            }, {
            getCustomDateFunc: this.getCustomDate,
            isNonWorkingTimeFunc: this.isNonWorkingTime,
            getNonAgendaViewBodyCellBgColorFunc: this.getPlanningWeekendCellBgColor,
        });
        // schedulerData.localeMoment.locale('en');
        schedulerData.setResources(resources);
        this.state = {
            id: 0,
            completeTime: 0,
            remainingTime: 0,
            operationHours: 24,
            list: [],
            jobnolist: [],
            products: [],
            toolings: [],
            machines: [],
            modalShow: false,
            newMode: true,
            newModalShow: false,
            body: [],
            boms: [],
            mouldLifeBalance: 0,
            machineNo: '',
            jobNo: '',
            masterJobNo: '',
            includeMasterJobNo: false,
            lineNo: '',
            actOutput: 0,
            jsQuantity: 0,
            machineTonnage: 0,
            mouldNo: '',
            mouldType: '',
            partWeight: 0,
            partNo: '',
            partDesc: '',
            partRunnerWeight: 0,
            pickingMode: false,
            cavityNo: 0,
            customer: '',
            po: '',
            cycleTime: 0,
            riskClass: 0,
            oee: 0,
            productivity: 0,
            executionNumber: 0,
            jobOrder: 0,
            total_output: 0,
            total_reject: 0,
            total_loss: 0,
            actOutput: 0,
            planOutput: 0,
            engReject: 0,
            prdReject: 0,
            machineDown: 0,
            mouldBreakdown: 0,
            jigFixture: 0,
            engineeringBuild: 0,
            machineSupportDoc: 0,
            manpower: 0,
            facility: 0,
            materialDelay: 0,
            unplanBriefing: 0,
            viewModel: schedulerData,
            allProcess: '',
            processes: [],
            process: 0,
            selectedMachine: 0,
            selectedDate: moment().format('YYYY-MM-DD'),
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD'),
            displayColorPicker: false,
            suggestions: [],
            jobsuggestions: [],
            toolingSuggestions: [],
            remark: '',
            color: '#4A90E2',
            uoms: [],
            sources: [],
            categories: [],
            materialBatchNo: '',
            toolingCondition: -1,
            loadingEvents: true,
            loadingEventDetails: false,
        }
        this.baseState = {
            ...this.state,
            loadingEvents: false,
            loadingEventDetails: false
        };
        this.loadData();

        //set locale moment to the schedulerData, if your locale isn't English. By default, Scheduler comes with English(en, United States).
        // moment.locale('zh-cn');
    }

    setLoadingEvents = (loadingEvents) => {
        if (this._isMounted) {
            this.setState({ loadingEvents });
        } else {
            this.state.loadingEvents = loadingEvents;
        }
    }

    loadData(d) {
        this.setLoadingEvents(true);
        let date = this.state.selectedDate;
        if (d != null)
            date = d;
        const accountId = JSON.parse(localStorage.getItem('user')).accountId;

        fetch(`${config.apiUrl}/getMasterDataByCompany?company=${accountId}&ignore_limit=true`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);

                    return data;
                });
            })
            .then(body => {
                this.setState({ list: body.data });
            });

        fetch(`${config.apiUrl}/getToolingByCompany?company=${accountId}&keyword=&limit=1000&offset=0`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);

                    return data;
                });
            })
            .then(body => {
                const toolings = body && body.data && Array.isArray(body.data) ? body.data : (Array.isArray(body) ? body : []);
                this.setState({ toolings });
            });

        // Only fetch job suggestions if accountId is 2
        if (accountId === 2) {
            fetch(`${config.apiUrl}/getSoltemJobNoList`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    this.setState({ jobnolist: body });
                });
        }

        // Now fetch planning events
        fetch(`${config.apiUrl}/getPlanning?company=${JSON.parse(localStorage.getItem('user')).accountId}&start=${moment(date).format('YYYY-MM-DD')}&end=${moment(date).add(14, 'days').format('YYYY-MM-DD')}&process=${this.state.process}&machine=${this.state.selectedMachine}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            })
            .then(event => {
                // Get unique jobIDs from events
                const uniqueJobIDs = [...new Set(event.filter(e => e.jobID).map(e => e.jobID))];

                // Fetch job details for all unique jobIDs to determine closed status
                const jobPromises = uniqueJobIDs.map(jobID =>
                    fetch(`${config.apiUrl}/getJobByFilter?id=${jobID}`, requestOptions)
                        .then(res => res.text().then(text => text && JSON.parse(text)))
                        .then(job => {
                            if (job && job.partNo && job.jobNo) {
                                const company = JSON.parse(localStorage.getItem('user')).accountId;
                                // Get total_output using getCurrentTotalQty API (exact jobNo + company)
                                return fetch(`${config.apiUrl}/getCurrentTotalQty?partNo=${encodeURIComponent(job.partNo || '')}&jobNo=${encodeURIComponent(job.jobNo || '')}&company=${encodeURIComponent(company || '')}`, requestOptions)
                                    .then(res => res.text().then(text => text && JSON.parse(text)))
                                    .then(result => {
                                        const totalOutput = this.safeNumber(
                                            result && result[0] ? result[0].total_output : 0
                                        );
                                        const jsQuantity = this.safeNumber(job.jsQuantity);
                                        // Must coerce to Number: Postgres BIGINT/SUM often arrives as strings.
                                        // Lexicographic "100" <= "99" is true and wrongly marks CLOSED.
                                        // Also ignore jsQuantity <= 0 (missing qty should not count as closed).
                                        return {
                                            jobID,
                                            isClosed: jsQuantity > 0 && jsQuantity <= totalOutput
                                        };
                                    });
                            }
                            return { jobID, isClosed: false };
                        })
                        .catch(err => {
                            console.error(`Error fetching job ${jobID}:`, err);
                            return { jobID, isClosed: false };
                        })
                );

                // Wait for all job status checks to complete
                return Promise.all(jobPromises).then(jobStatuses => {
                    // Create a Set of closed jobIDs for quick lookup
                    const closedJobIDs = new Set();
                    jobStatuses.forEach(status => {
                        if (status.isClosed) {
                            closedJobIDs.add(status.jobID);
                        }
                    });

                    schedulerData.setDate(moment(date).format(DATE_FORMAT));
                    // Last scheduler row (resourceId "2") = daily manpower totals
                    let twoweeks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                    event.map((item, index) => {
                        item.oldId = item.id;
                        item.id = index;

                        // If start and end date is same, the duration of the event was evaluated as 0,
                        // so we need to add 1 day to the end date
                        if (item.start === item.end) {
                            item.end = moment(item.end).format('YYYY-MM-DD 23:59:59');
                        }

                        // Skip any leftover manpower-summary events if API ever returns them
                        if (String(item.resourceId) === '2') {
                            return;
                        }

                        // Title format: partNo(manpower) e.g. ABC123(2)
                        // Must parse BEFORE appending [CLOSED], and use last (...) in case partNo has parens
                        const titleText = String(item.title || '');
                        const parenGroups = titleText.match(/\(([^)]*)\)/g) || [];
                        const lastGroup = parenGroups.length
                            ? parenGroups[parenGroups.length - 1].replace(/^\(|\)$/g, '')
                            : '';
                        const manpowerValue = this.safeNumber(lastGroup, 0);

                        if (closedJobIDs.has(item.jobID) && titleText.indexOf('[CLOSED]') === -1) {
                            item.title = titleText + ' [CLOSED]';
                        }

                        let selected_start = moment(item.start).diff(moment(date), 'days');
                        let selected_end = moment(item.end).diff(moment(date), 'days');
                        for (let i = selected_start; i <= selected_end; i++) {
                            if (i < 0 || i >= twoweeks.length) continue;
                            const dayDate = moment(date).add(i, 'days');
                            if (dayDate.day() === 0) continue; // Sunday off
                            twoweeks[i] += manpowerValue;
                        }
                    });
                    let selectedDate = date;
                    for (let i = 0; i < twoweeks.length; i++) {
                        const dayTotal = Number.isFinite(twoweeks[i]) ? twoweeks[i] : 0;
                        event.push({
                            id: Number(i + 1000001),
                            start: selectedDate + ' 00:00:00',
                            end: selectedDate + ' 23:59:59',
                            title: String(dayTotal) + ' ',
                            resourceId: "2",
                            bgColor: '#2196F3',
                        });
                        selectedDate = moment(selectedDate).add(1, 'days').format(DATE_FORMAT);
                    }
                    schedulerData.setEvents(event);
                    this.setState({
                        viewModel: schedulerData,
                        loadingEvents: false
                    });
                });
            })
            .catch(error => {
                console.error('Error loading planning events:', error);
                this.setLoadingEvents(false);
            });
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillMount() {
        this._isMounted = false;

        this.setState({
            machines: []
        });

        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getAllMachines?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    // login successful if there's a user in the response
                    if (machine) {
                        this.setState({ machines: machine });
                        fetch(`${config.apiUrl}/getAllProcesses?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                            .then((response) => {
                                return response.text().then(text => {
                                    const data = text && JSON.parse(text);

                                    return data;
                                });
                            })
                            .then(process => {
                                // login successful if there's a user in the response
                                if (process) {
                                    this.setState({ processes: process });

                                }
                            });
                    }
                });
        }

    }

    onChange = (event, { newValue }) => {
        this.setState({
            partNo: typeof newValue !== 'undefined' ? newValue : '',
        });
    };

    onJobNoChange = (event, { newValue }) => {
        this.setState({
            jobNo: typeof newValue !== 'undefined' ? newValue : '',

        });
    };

    onToolingNoChange = (event, { newValue }) => {
        this.setState({
            mouldNo: typeof newValue !== 'undefined' ? newValue : '',
        });
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value, this.state.list)
        });
    };

    onJobSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            jobsuggestions: getJobSuggestions(value, this.state.jobnolist)
        });
    };

    onToolingSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            toolingSuggestions: getToolingSuggestions(value, this.state.toolings)
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onJobSuggestionsClearRequested = () => {
        this.setState({
            jobsuggestions: []
        });
    };

    onToolingSuggestionsClearRequested = () => {
        this.setState({
            toolingSuggestions: []
        });
    };


    // When suggestion is clicked, Autosuggest needs to populate the input
    // based on the clicked suggestion. Teach Autosuggest how to calculate the
    // input value for every given suggestion.
    getSuggestionValue = (suggestion) => {
        // Use _currentJobNo which is updated synchronously, avoiding async setState race conditions
        const jobNo = this._currentJobNo || this.state.jobNo;

        fetch(`${config.apiUrl}/getCurrentTotalQty?partNo=${encodeURIComponent(suggestion.partNo || '')}&jobNo=${encodeURIComponent(jobNo || '')}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            })
            .then(result => {
                this.getBom(suggestion.id);
                const currentTotal = result && result[0] ? result[0] : {};
                const totalOutput = this.safeNumber(currentTotal.total_output);
                this.fetchAndApplyToolingData({ partNo: suggestion.partNo }, totalOutput);

                if (currentTotal.total_output != null) {
                    const synced = this.syncDerivedScheduleFields({
                        total_output: currentTotal.total_output,
                        cycleTime: this.state.cycleTime,
                        jsQuantity: this.state.jsQuantity,
                    });
                    this.setState({
                        total_output: currentTotal.total_output,
                        total_reject: currentTotal.total_reject,
                        total_loss: currentTotal.total_loss,
                        remainingTime: synced.remainingTime,
                        completeTime: synced.completeTime,
                        end: synced.end,
                    });
                }
            });

        this.setState({
            ...suggestion,
            cavityNo: 0,
            mouldLifeBalance: 0
        });
        const synced = this.syncDerivedScheduleFields({
            cycleTime: suggestion.cycleTime,
            jsQuantity: this.state.jsQuantity,
        });
        this.setState({
            id: 0,
            cycleTime: suggestion.cycleTime,
            completeTime: synced.completeTime,
            remainingTime: synced.remainingTime,
            end: synced.end,
            start: synced.start,
            masterID: suggestion.id,
            allProcess: concatProcesses(suggestion)
        });

        return suggestion.partNo

        function concatProcesses(suggestion) {
            // Check new format: process column (comma-separated string)
            if (suggestion.process && suggestion.process.trim() !== '') {
                return suggestion.process;
            }

            // Fallback to legacy format: process1-5
            let i = 1,
                processes = '';

            do {
                if (suggestion[`process${i}`] !== '') {
                    processes += suggestion[`process${i}`] + ', ';
                }
                i++;
            } while (suggestion[`process${i}`] !== undefined);
            // remove the last comma
            processes = processes.slice(0, -2);

            return processes;
        }
    };

    getToolingSuggestionValue = (suggestion) => {
        this.fetchAndApplyToolingData(suggestion, this.state.total_output);

        return suggestion.toolingNo || '';
    };

    safeNumber = (value, fallback = 0) => {
        if (value === null || value === undefined || value === '') return fallback;
        const numberValue = Number(value);
        return isNaN(numberValue) ? fallback : numberValue;
    };

    calcCompleteTime = (jsQuantity, cycleTime, operationHours) =>
        calcCompleteTimeHours(jsQuantity, cycleTime, operationHours ?? this.state.operationHours);

    calcEndDate = (start, completeTimeHours, operationHours) => {
        const opHrs = operationHours ?? this.state.operationHours ?? 24;
        // Complete Time is scaled by 24/opHrs; End packs machine hours into daily shifts.
        const productionHours = productionHoursFromCompleteTime(completeTimeHours, opHrs);
        return formatPlanningEndDate(start, productionHours, true, opHrs);
    };

    calcStartDate = (start) =>
        formatPlanningStartDate(start, true, this.state.operationHours || 24);

    calcRemainingTime = (jsQuantity, totalOutput, cycleTime, operationHours) =>
        calcRemainingTimeHours(jsQuantity, totalOutput, cycleTime, operationHours ?? this.state.operationHours);

    /**
     * Keep Complete / Remaining / End in sync when schedule or qty-related fields change.
     * - Default: derive Complete/Remaining from qty/cycle/opHrs, then End from Start + Complete.
     * - fromEnd: derive Complete from working hours between Start–End, Remaining scales with output.
     */
    syncDerivedScheduleFields = (overrides = {}) => {
        const jsQuantity = overrides.jsQuantity !== undefined ? overrides.jsQuantity : this.state.jsQuantity;
        const total_output = overrides.total_output !== undefined ? overrides.total_output : this.state.total_output;
        const cycleTime = overrides.cycleTime !== undefined ? overrides.cycleTime : this.state.cycleTime;
        const operationHours = Number(
            overrides.operationHours !== undefined ? overrides.operationHours : this.state.operationHours
        ) || 24;
        const fromEnd = overrides.fromEnd === true;

        let start = overrides.start !== undefined ? overrides.start : this.state.start;
        start = formatPlanningStartDate(start, true, operationHours);

        let end;
        let completeTime;
        let remainingTime;

        if (fromEnd) {
            end = overrides.end !== undefined ? overrides.end : this.state.end;
            const productionHours = countPlanningWorkingHours(start, end, operationHours);
            completeTime = Math.round(productionHours * (24 / operationHours)) || 1;
            const qty = Number(jsQuantity) || 0;
            const output = Number(total_output) || 0;
            if (qty > 0) {
                remainingTime = Math.round(completeTime * Math.max(0, qty - output) / qty);
            } else {
                remainingTime = completeTime;
            }
        } else {
            completeTime = this.calcCompleteTime(jsQuantity, cycleTime, operationHours) || 1;
            remainingTime = this.calcRemainingTime(jsQuantity, total_output, cycleTime, operationHours);
            end = this.calcEndDate(start, completeTime, operationHours);
        }

        return {
            start,
            end,
            completeTime,
            remainingTime,
            operationHours,
        };
    };

    normalizeDraggedSchedule = (start, end) => {
        const opHrs = this.state.operationHours || 24;
        const normalizedStart = formatPlanningStartDate(start, true, opHrs);
        // Drag span is already machine/shift hours (not 24/opHrs scaled).
        const dragHours = countPlanningWorkingHours(normalizedStart, end, opHrs);
        const normalizedEnd = formatPlanningEndDate(normalizedStart, dragHours, true, opHrs);
        return { start: normalizedStart, end: normalizedEnd };
    };

    normalizeToolingResponse = (body) => {
        if (!body) return null;
        if (Array.isArray(body)) return body[0] || null;
        if (body.data && Array.isArray(body.data)) return body.data[0] || null;
        return body.data || body;
    };

    findToolingByNo = (toolingNo) => {
        const value = String(toolingNo || '').trim();
        if (!value) return null;
        return (this.state.toolings || []).find(item => String(item.toolingNo || '').trim() === value) || null;
    };

    findToolingByPartNo = (partNo) => {
        const value = String(partNo || '').trim();
        if (!value) return null;
        return (this.state.toolings || []).find(item => String(item.partNo || '').trim() === value) || null;
    };

    findToolingById = (toolingId) => {
        const value = String(toolingId || '').trim();
        if (!value) return null;
        return (this.state.toolings || []).find(item => String(item.id || '').trim() === value) || null;
    };

    getToolingQuery = (toolingSource) => {
        const tooling = typeof toolingSource === 'string'
            ? (this.findToolingByNo(toolingSource) || this.findToolingById(toolingSource) || { toolingNo: toolingSource })
            : toolingSource;

        if (!tooling) return '';
        if (tooling.id) return `id=${encodeURIComponent(tooling.id)}`;
        if (tooling.partNo) {
            const matchedTooling = this.findToolingByPartNo(tooling.partNo);
            if (matchedTooling && matchedTooling.id) return `id=${encodeURIComponent(matchedTooling.id)}`;

            const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
            const companyQuery = user && user.accountId ? `&company=${encodeURIComponent(user.accountId)}` : '';
            return `partNo=${encodeURIComponent(tooling.partNo)}${companyQuery}`;
        }
        if (tooling.toolingNo) return `toolingNo=${encodeURIComponent(tooling.toolingNo)}`;
        return '';
    };

    fetchAndApplyToolingData = (toolingSource, totalOutput = 0) => {
        const query = this.getToolingQuery(toolingSource);
        if (!query) return Promise.resolve(null);

        return fetch(`${config.apiUrl}/getOneTooling?${query}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            })
            .then(body => {
                const tooling = this.normalizeToolingResponse(body);
                if (!tooling) return null;

                const toolingLife = this.safeNumber(tooling.toolingLife);
                const noCavity = this.safeNumber(tooling.noCavity, 1) || 1;
                const toolingCondition = this.safeNumber(tooling.toolingCondition);
                const machineTonnage = this.safeNumber(tooling.machineTonnage);

                this.setState({
                    mouldNo: tooling.toolingNo || this.state.mouldNo,
                    mouldType: tooling.toolingSystem || '',
                    cavityNo: noCavity,
                    toolingCondition,
                    machineTonnage,
                    mouldLifeBalance: Math.round(toolingLife - (this.safeNumber(totalOutput) / noCavity))
                });

                return tooling;
            })
            .catch(err => {
                console.error('Error fetching tooling data:', err);
                return null;
            });
    };

    // Debounced fetch for Master Job No - loads Part No and related info
    _masterJobNoDebounceTimer = null;
    fetchMasterJobNoData = (masterJobNoValue) => {
        if (this._masterJobNoDebounceTimer) {
            clearTimeout(this._masterJobNoDebounceTimer);
        }
        this._masterJobNoDebounceTimer = setTimeout(() => {
            if (!masterJobNoValue || masterJobNoValue.trim() === '') return;
            fetch(`${config.apiUrl}/getMasterDataByMasterJobNo?masterJobNo=${encodeURIComponent(masterJobNoValue)}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(results => {
                    const data = Array.isArray(results) ? results[0] : results;
                    if (data && data.master) {
                        const master = data.master;
                        const allProcess = master.process || '';
                        const jsQuantity = data.jsQuantity || this.state.jsQuantity;
                        const synced = this.syncDerivedScheduleFields({
                            cycleTime: master.cycleTime || 0,
                            jsQuantity,
                            total_output: data.total_output || 0,
                        });
                        this.setState({
                            partNo: master.partNo || '',
                            partDesc: master.partDesc || '',
                            partWeight: master.partWeight || '',
                            partRunnerWeight: master.partRunnerWeight || '',
                            cycleTime: master.cycleTime || 0,
                            customer: master.customer || '',
                            riskClass: master.riskClass || 'select',
                            allProcess: allProcess,
                            masterID: master.id,
                            completeTime: synced.completeTime,
                            remainingTime: synced.remainingTime,
                            end: synced.end,
                            start: synced.start,
                            jsQuantity,
                            manpower: this.safeNumber(data.manpower, this.safeNumber(this.state.manpower, 0)),
                            po: data.po || this.state.po,
                            machineNo: data.machineNo || this.state.machineNo,
                            lineNo: data.lineNo || this.state.lineNo,
                            remark: data.remark || this.state.remark,
                            total_output: data.total_output || 0,
                            total_reject: data.total_reject || 0,
                            total_loss: data.total_loss || 0,
                            materialBatchNo: data.materialBatchNo || this.state.materialBatchNo,
                        }, () => {
                            this.fetchAndApplyToolingData(master.mouldNo, data.total_output || 0);
                        });
                        this.getBom(master.id);
                    }
                })
                .catch(err => {
                    console.error('Error fetching master data by Master Job No:', err);
                });
        }, 500);
    };

    getBom(masterID) {
        fetch(`${config.apiUrl}/getBomList?master_data_id=${masterID}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const ret = text && JSON.parse(text);
                    return ret.data ? ret.data : [];
                });
            })
            .then(data => {
                fetch(`${config.apiUrl}/getAllMaterialUom`, requestOptions)
                    .then((response) => {
                        return response.text().then(text => {
                            const data = text && JSON.parse(text);

                            return data;
                        });
                    })
                    .then(uom => {
                        // login successful if there's a user in the response
                        if (uom) {
                            this.setState({ uoms: uom });
                        }
                        fetch(`${config.apiUrl}/getAllMaterialSource`, requestOptions)
                            .then((response) => {
                                return response.text().then(text => {
                                    const data = text && JSON.parse(text);

                                    return data;
                                });
                            })
                            .then(source => {
                                // login successful if there's a user in the response
                                if (source) {
                                    this.setState({ sources: source });
                                }
                                fetch(`${config.apiUrl}/getAllMaterialCategory`, requestOptions)
                                    .then((response) => {
                                        return response.text().then(text => {
                                            const data = text && JSON.parse(text);

                                            return data;
                                        });
                                    })
                                    .then(category => {
                                        // login successful if there's a user in the response
                                        if (category) {
                                            this.setState({ categories: category });
                                            data.map((obj, i) => {
                                                obj.no = (i + 1);
                                                obj.total = (obj.usage * obj.per * this.state.jsQuantity).toFixed(2);
                                                obj.category = utils.mapTo(this.state.categories, obj.category);
                                                obj.uom = utils.mapTo(this.state.uoms, obj.uom);
                                                obj.source = utils.mapTo(this.state.sources, obj.source);
                                            });
                                            this.setState({ boms: data });
                                        }
                                    });
                            });

                    });
            });

    }

    getPartNoValue = (jobsuggestion, shouldFetchPartNo = false) => {
        // Early return if this is just for display (getOptionLabel calls)
        if (!shouldFetchPartNo) {
            // Just return the jobNo string for display purposes, don't do anything else
            // This prevents any side effects when called during rendering
            if (!jobsuggestion) return '';
            const jobNo = typeof jobsuggestion === 'string' ? jobsuggestion : (jobsuggestion.jobNo || '');
            return jobNo;
        }

        // Only proceed if shouldFetchPartNo is true (explicit user action)
        console.log('getPartNoValue called with shouldFetchPartNo=true for:', jobsuggestion?.jobNo);

        // Safety check: ensure we have a valid jobNo
        if (!jobsuggestion || !jobsuggestion.jobNo) {
            return jobsuggestion?.jobNo || '';
        }

        const accountId = JSON.parse(localStorage.getItem('user')).accountId;

        // Only call getPartNolistFromSolteam if accountId is 2 AND shouldFetchPartNo is true
        // shouldFetchPartNo should only be true when explicitly called from user action
        if (accountId === 2 && jobsuggestion.jobNo) {
            // Only make API call if jobNo is exactly 15 characters
            if (jobsuggestion.jobNo.length === 15) {
                fetch(`${config.apiUrl}/getPartNolistFromSolteam?jobNo=${jobsuggestion.jobNo}`, requestOptions)
                    .then((response) => {
                        return response.text().then(text => {
                            const data = text && JSON.parse(text);
                            return data;
                        });
                    })
                    .then(result => {
                        console.log('getPartNoValue API response:', result);
                        // Set partNo if it exists in the result, regardless of total_output
                        if (result && Array.isArray(result) && result.length > 0 && result[0].partNo) {
                            console.log('Setting partNo to:', result[0].partNo);
                            this.setState({
                                partNo: result[0].partNo,
                            });
                        } else if (result && result.partNo) {
                            // Handle case where result is an object, not an array
                            console.log('Setting partNo to:', result.partNo);
                            this.setState({
                                partNo: result.partNo,
                            });
                        } else {
                            console.log('No partNo found in result:', result);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching part number:', error);
                    });
            }
        }

        // Update state with the job suggestion
        this.setState(jobsuggestion);
        return jobsuggestion.jobNo
    };

    // Generate auto jobNo based on year + month + day + 6 digits random number
    generateAutoJobNo = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const randomNum = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
        return `${year}${month}${day}${randomNum}`;
    };

    onClickProductSelected(cell, row, rowIndex) {
        // Find the record in body by matching id
        const record = this.state.body.find(r => r.id === row.id) || (row.id ? row : null);
        if (!record) {
            return;
        }
        this.setState({ modalShow: true });
        this.setState({ newMode: false });
        this.setState({ timestamp: record.Timestamp });
        this.setState({ executionNumber: record.executionNumber });
        this.setState({ cycleTime: record.cycleTime });
        this.setState({ jobOrder: record.jobOrder });
        this.setState({ employeeID: record.employeeID });
        this.setState({ actOutput: record.actOutput });
        this.setState({ planOutput: record.planOutput });
        this.setState({ engReject: record.engReject });
        this.setState({ prdReject: record.prdReject });
        this.setState({ machineDown: record.machineDown });
        this.setState({ mouldBreakdown: record.mouldBreakdown });
        this.setState({ jigFixture: record.jigFixture });
        this.setState({ engineeringBuild: record.engineeringBuild });
        this.setState({ machineSupportDoc: record.machineSupportDoc });
        this.setState({ manpower: this.safeNumber(record.manpower, 0) });
        this.setState({ facility: record.facility });
        this.setState({ materialDelay: record.materialDelay });
        this.setState({ unplanBriefing: record.unplanBriefing });
        this.setState({ oee: record.oee });
        this.setState({ productivity: record.productivity });
        this.setState({ remark: record.remark });
        this.setState({ id: record.id });
    }

    onDeleteProduct(cell, row, rowIndex) {
        // Find the record in body by matching id, or use row.id directly
        const recordId = row && row.id ? row.id : (this.state.body && this.state.body[rowIndex] ? this.state.body[rowIndex].id : null);
        if (!recordId) {
            return;
        }
        fetch(`${config.apiUrl}/delete`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: recordId,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                }
            });
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        this.onClickProductSelected(cell, row, rowIndex)}
                >
                    Edit
                </button>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(cell, row, rowIndex)}
                >
                    Delete
                </button>
            </div>
        )
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color })
    };

    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessPlanningModule(user)) {
            return <Navigate to='/' />
        }

        const planningStyle = { display: 'block', padding: 0, margin: 0, background: 'transparent', height: '30px', border: 'none', borderRadius: 0, borderBottom: '1px solid #ccc', outline: 'none', boxShadow: 'none' };
        const styles = {
            color: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                backgroundColor: this.state.color,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: 10000,
                top: '100%',
                left: '0px',
                marginTop: '5px',
                backgroundColor: 'white',
                padding: '10px',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: 9999,
            },
            schedulerLoadingOverlay: {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                minHeight: '320px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '10px',
                backgroundColor: 'rgba(255,255,255,0.78)',
                color: '#333',
                zIndex: 20,
                fontWeight: 600,
            },
            eventDetailsLoadingOverlay: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255,255,255,0.62)',
                zIndex: 1050,
            },
            eventDetailsLoadingBox: {
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 18px',
                borderRadius: '6px',
                backgroundColor: '#ffffff',
                boxShadow: '0 8px 24px rgba(0,0,0,0.16)',
                color: '#333',
                fontWeight: 600,
            },
        };
        let { schedulerData, suggestions, jobsuggestions, toolingSuggestions, slotId, color, slotName, allProcess, total_loss, total_output, total_reject, start, end, type, item, viewModel, id, jobNo, jsQuantity, partDesc, partRunnerWeight, partWeight, cavityNo, customer, po, riskClass, machineNo, lineNo, machineTonnage, mouldNo, mouldType, mouldLifeBalance, remainingTime, completeTime, modalShow, newMode, partNo, cycleTime, manpower, remark, selectedDate, loadingEvents, loadingEventDetails } = this.state;
        const inputPropsJob = {
            placeholder: 'Type job no.',
            value: jobNo,
            onChange: this.onJobNoChange
        };
        const inputProps = {
            placeholder: 'Type part no.',
            value: partNo,
            onChange: this.onChange
        };
        const readOnlyPlanningStyle = { border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' };
        const renderJobNoField = () => {
            const accountId = JSON.parse(localStorage.getItem('user')).accountId;
            if (accountId === 2) {
                return <Autocomplete
                    freeSolo
                    size="small"
                    options={jobsuggestions}
                    filterOptions={(options) => options}
                    componentsProps={{
                        popper: {
                            style: { zIndex: 9999 }
                        }
                    }}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        return option.jobNo || '';
                    }}
                    isOptionEqualToValue={(option, value) => {
                        const optionJobNo = typeof option === 'string' ? option : option.jobNo;
                        const valueJobNo = typeof value === 'string' ? value : value.jobNo;
                        return optionJobNo === valueJobNo;
                    }}
                    onInputChange={(event, value, reason) => {
                        this._currentJobNo = value || '';
                        this.setState({ jobNo: value || '' });

                        if (value && value.length === 15 && accountId === 2 && reason === 'input') {
                            this.getPartNoValue({ jobNo: value }, true);
                        }

                        if (value) {
                            this.onJobSuggestionsFetchRequested({ value });
                        } else {
                            this.onJobSuggestionsClearRequested();
                        }
                    }}
                    onChange={(event, value, reason) => {
                        if (value && (reason === 'selectOption' || reason === 'createOption')) {
                            const jobNoValue = typeof value === 'string' ? value : (value.jobNo || '');
                            this._currentJobNo = jobNoValue;
                            this.setState({ jobNo: jobNoValue });

                            if (jobNoValue && accountId === 2) {
                                const jobSuggestion = typeof value === 'string' ? { jobNo: jobNoValue } : value;
                                this.getPartNoValue(jobSuggestion, true);
                            }
                        }
                    }}
                    renderOption={(props, option) => (
                        <li {...props}>
                            {renderJobSuggestion(option)}
                        </li>
                    )}
                    renderInput={(params) => {
                        const { onChange, ...restInputProps } = inputPropsJob;
                        return (
                            <TextField
                                {...params}
                                {...restInputProps}
                                size="small"
                                variant="outlined"
                            />
                        );
                    }}
                />;
            }

            return <input
                className="form-control"
                style={planningStyle}
                value={jobNo}
                onChange={(e) => {
                    this._currentJobNo = e.target.value;
                    this.setState({ jobNo: e.target.value });
                }}
                placeholder="Enter Job No"
            />;
        };
        const partNoField = <Autocomplete
            freeSolo
            size="small"
            options={suggestions}
            filterOptions={(options) => options}
            value={partNo || null}
            componentsProps={{
                popper: {
                    style: { zIndex: 9999 }
                }
            }}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.partNo || '';
            }}
            onInputChange={(event, value) => {
                this.setState({ partNo: value || '' });
                if (value) {
                    this.onSuggestionsFetchRequested({ value });
                } else {
                    this.onSuggestionsClearRequested();
                }
            }}
            onChange={(event, value) => {
                if (value) {
                    const partNoValue = typeof value === 'string' ? value : value.partNo;
                    this.getSuggestionValue(typeof value === 'string' ? { partNo: partNoValue } : value);
                }
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    {renderSuggestion(option)}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Type part no."
                    size="small"
                    variant="outlined"
                />
            )}
        />;
        const toolingNoField = <Autocomplete
            freeSolo
            size="small"
            options={toolingSuggestions}
            filterOptions={(options) => options}
            value={mouldNo || null}
            componentsProps={{
                popper: {
                    style: { zIndex: 9999 }
                }
            }}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.toolingNo || '';
            }}
            isOptionEqualToValue={(option, value) => {
                const optionToolingNo = typeof option === 'string' ? option : option.toolingNo;
                const valueToolingNo = typeof value === 'string' ? value : value.toolingNo;
                return optionToolingNo === valueToolingNo;
            }}
            onInputChange={(event, value) => {
                this.setState({ mouldNo: value || '' });
                if (value) {
                    this.onToolingSuggestionsFetchRequested({ value });
                } else {
                    this.onToolingSuggestionsClearRequested();
                }
            }}
            onChange={(event, value) => {
                if (value && typeof value !== 'string') {
                    this.getToolingSuggestionValue(value);
                } else {
                    this.setState({ mouldNo: value || '' });
                }
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    {renderToolingSuggestion(option)}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Type tooling no."
                    size="small"
                    variant="outlined"
                />
            )}
        />;
        let handleClose = () => this.setState({
            ...this.baseState,
            list: this.state.list,
            jobnolist: this.state.jobnolist,
            toolings: this.state.toolings,
            modalShow: false,
        });
        let handleSave = () => {
            let { machineNo, lineNo, mouldLifeBalance, completeTime, jobNo, masterJobNo, includeMasterJobNo, remainingTime, company, total_loss, total_reject, total_output, partNo, jsQuantity, po, manpower, remark, masterID, start, end, color, slotId, jobID, operationHours, materialBatchNo, mouldNo } = this.state;
            const selectedTooling = this.findToolingByNo(mouldNo);
            const toolingID = selectedTooling ? selectedTooling.id : null;
            let startWith = '';
            window.confirm("Are you sure you update this data?") && fetch(`${config.apiUrl}/updateJobsheet`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    machineNo,
                    jobNo,
                    masterJobNo: includeMasterJobNo ? masterJobNo : '',
                    lineNo,
                    mouldLifeBalance,
                    jsQuantity,
                    po,
                    manpower,
                    remark,
                    completeTime,
                    remainingTime,
                    total_loss,
                    total_reject,
                    total_output,
                    masterID,
                    toolingID,
                    operationHours,
                    materialBatchNo,
                    id: jobID,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        if (machineNo.length > 0)
                            startWith = 'M' + machineNo + ' ';
                        if (lineNo.length > 0)
                            startWith = 'L' + lineNo + ' ';
                        fetch(`${config.apiUrl}/updatePlanning`, {
                            method: "post",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },

                            //make sure to serialize your JSON body
                            body: JSON.stringify({
                                start,
                                end,
                                resourceId: slotId,
                                bgColor: color.toUpperCase(),
                                title: startWith + partNo + '(' + manpower + ')',
                                company: JSON.parse(localStorage.getItem('user')).accountId,
                                jobID
                            })
                        })
                            .then((response) => {
                                if (response.status == 200) {
                                    this.loadData();
                                    window.alert('Update Successfully.');
                                    this.setState({ modalShow: false });
                                }
                            });
                    }
                });
        }

        let handleCreate = () => {
            let { machineNo, jobNo, masterJobNo, includeMasterJobNo, lineNo, mouldLifeBalance, completeTime, remainingTime, company, total_loss, total_reject, total_output, partNo, jsQuantity, po, manpower, remark, masterID, start, end, color, slotId, selectedDate, operationHours, materialBatchNo, mouldNo } = this.state;
            const selectedTooling = this.findToolingByNo(mouldNo);
            const toolingID = selectedTooling ? selectedTooling.id : null;
            let startWith = '';
            fetch(`${config.apiUrl}/uploadJobsheet`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    machineNo,
                    jobNo,
                    masterJobNo: includeMasterJobNo ? masterJobNo : '',
                    lineNo,
                    mouldLifeBalance,
                    jsQuantity,
                    po,
                    manpower,
                    remark,
                    completeTime,
                    remainingTime,
                    total_loss,
                    total_reject,
                    total_output,
                    masterID,
                    toolingID,
                    operationHours,
                    materialBatchNo
                })
            })
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(data => {
                    if (data) {
                        if (machineNo.length > 0)
                            startWith = 'M' + machineNo + ' ';
                        if (lineNo.length > 0)
                            startWith = 'L' + lineNo + ' ';

                        fetch(`${config.apiUrl}/uploadPlanning`, {
                            method: "post",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },

                            //make sure to serialize your JSON body
                            body: JSON.stringify({
                                start,
                                end,
                                resourceId: slotId,
                                bgColor: color.toUpperCase(),
                                title: startWith + partNo + '(' + manpower + ')',
                                company: JSON.parse(localStorage.getItem('user')).accountId,
                                jobID: data.id
                            })
                        })
                            .then((response) => {
                                if (response.status == 200) {
                                    this.setState({ modalShow: false });
                                    this.setState({ newMode: false });
                                    let newFreshId = 0;

                                    schedulerData.events.forEach((item) => {
                                        if (item.id >= newFreshId)
                                            newFreshId = item.id + 1;
                                    });

                                    let newEvent = {
                                        id: newFreshId,
                                        title: startWith + partNo + '(' + manpower + ')',
                                        start: start,
                                        end: end,
                                        resourceId: slotId,
                                        company: JSON.parse(localStorage.getItem('user')).accountId,
                                        bgColor: color.toUpperCase(),
                                        jobID: data.id
                                    }
                                    this.setState({
                                        viewModel: schedulerData
                                    })
                                    this.loadData();
                                }
                            });
                    }
                });
        }

        return (
            <div class="container">
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <CustomDatePicker
                            label="Start Date"
                            controlId="formInlineDate"
                            value={this.state.selectedDate}
                            onChange={(value) => { this.setState({ selectedDate: value }); }}
                        />{' '}
                        <Button
                            bsStyle="primary"
                            // disabled={isLoading}
                            // onClick={!isLoading ? this.handleClick : null}
                            onClick={e => this.loadData()}>Show</Button>
                        {this.state.machine && this.state.start && (<Button
                            style={{ right: 0, position: 'absolute' }}
                            bsStyle="danger"
                            visi
                            onClick={e => {
                                const accountId = JSON.parse(localStorage.getItem('user')).accountId;
                                const autoJobNo = accountId !== 2 ? this.generateAutoJobNo() : '';
                                this.setState({
                                    modalShow: true,
                                    newMode: true,
                                    jobNo: autoJobNo,
                                    masterJobNo: '',
                                    includeMasterJobNo: false
                                });
                            }}>New</Button>)}

                    </Form>
                    <div className="planning-scheduler" style={{ marginTop: 10, width: '80%', position: 'relative', minHeight: '320px' }}>
                        <Scheduler
                            schedulerData={this.state.viewModel}
                            showHeader={false}
                            eventItemTemplateResolver={this.eventItemTemplateResolver}
                            prevClick={() => { }}
                            nextClick={() => { }}
                            onSelectDate={() => { }}
                            onViewChange={this.onViewChange}
                            updateEventStart={this.updateEventStart}
                            updateEventEnd={this.updateEventEnd}
                            moveEvent={this.moveEvent}
                            movingEvent={this.movingEvent}
                            newEvent={this.newEvent}
                            toggleExpandFunc={this.toggleExpandFunc}
                        />
                        {loadingEvents && (
                            <div style={styles.schedulerLoadingOverlay}>
                                <DatacoLoadingIndicator loading={loadingEvents} variant="overlay" size="compact" label="Loading planning events" />
                            </div>
                        )}
                    </div>
                </div>

                {loadingEventDetails && (
                    <div style={styles.eventDetailsLoadingOverlay}>
                        <div style={styles.eventDetailsLoadingBox}>
                            <DatacoLoadingIndicator loading={loadingEventDetails} size="compact" label="Loading event details" />
                        </div>
                    </div>
                )}

                <Modal dialogClassName="modal-90w" show={modalShow} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '20px' }}>
                                <div>
                                    {this.state.pickingMode == true ? 'Picking List' : (newMode ? 'New Job' : 'Edit Job')}
                                </div>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    {this.state.pickingMode == false ? (
                                        <Button variant="secondary" onClick={e => this.setState({ pickingMode: true })}>Picking List</Button>
                                    ) : (
                                        <Button variant="secondary" onClick={e => this.setState({ pickingMode: false })}>Back</Button>
                                    )}
                                    <ReactToPrint
                                        trigger={() => <Button variant="secondary">Print</Button>}
                                        content={() => this.componentRef}
                                    />
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.pickingMode == false ? <div>
                            <Form ref={el => (this.componentRef = el)} className="planning-job-form">
                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Schedule</div>
                                    <p className="text-muted small mb-2">
                                        Working week: Monday 7:00 to Saturday 7:00. Changing Start, End, Operation Hours, JO Qty, Part, or actual output auto-updates Complete Time, Remaining Time, and End.
                                    </p>
                                    <Row>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Start</Form.Label>
                                            <input className="form-control" style={planningStyle} value={moment(start).format('YYYY-MM-DD')} type="date"
                                                onChange={(e) => {
                                                    const synced = this.syncDerivedScheduleFields({
                                                        start: e.target.value + " 00:00:00",
                                                    });
                                                    this.setState(synced);
                                                }}
                                            />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>End</Form.Label>
                                            <input className="form-control" style={planningStyle} value={moment(end).format('YYYY-MM-DD')} type="date"
                                                onChange={(e) => {
                                                    const synced = this.syncDerivedScheduleFields({
                                                        end: e.target.value + " 23:59:59",
                                                        fromEnd: true,
                                                    });
                                                    this.setState(synced);
                                                }}
                                            />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Operation Hours</Form.Label>
                                            <FormControl as="select" value={this.state.operationHours} onChange={(e) => {
                                                const synced = this.syncDerivedScheduleFields({
                                                    operationHours: Number(e.target.value),
                                                });
                                                this.setState(synced);
                                            }}>
                                                <option value={10}>10</option>
                                                <option value={12}>12</option>
                                                <option value={24}>24</option>
                                            </FormControl>
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Color</Form.Label>
                                            <div className="planning-color-control">
                                                <div style={styles.swatch} onClick={this.handleClick}>
                                                    <div style={styles.color} />
                                                </div>
                                                {this.state.displayColorPicker ? (
                                                    <>
                                                        <div style={styles.cover} onClick={this.handleClose} />
                                                        <div style={styles.popover} onClick={(e) => e.stopPropagation()}>
                                                            <HexColorPicker color={color} onChange={this.handleChange} />
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Job Details</div>
                                    <Row>
                                        <Col md={6} sm={12} className="planning-form-field">
                                            <Form.Label>Job No</Form.Label>
                                            {renderJobNoField()}
                                            <div style={{ marginTop: '10px' }}>
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Include Master Job No"
                                                    checked={this.state.includeMasterJobNo}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        const accountId = JSON.parse(localStorage.getItem('user')).accountId;
                                                        this.setState({
                                                            includeMasterJobNo: checked,
                                                            masterJobNo: checked && !this.state.masterJobNo ? (accountId !== 2 ? this.generateAutoJobNo() : '') : this.state.masterJobNo
                                                        });
                                                    }}
                                                />
                                            </div>
                                            {this.state.includeMasterJobNo && (
                                                <div style={{ marginTop: '10px' }}>
                                                    <Form.Label>Master Job No</Form.Label>
                                                    <input
                                                        className="form-control"
                                                        style={planningStyle}
                                                        value={this.state.masterJobNo}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            this.setState({ masterJobNo: val });
                                                            this.fetchMasterJobNoData(val);
                                                        }}
                                                        placeholder="Enter or paste Master Job No"
                                                    />
                                                </div>
                                            )}
                                        </Col>
                                        <Col md={4} sm={12} className="planning-form-field">
                                            <Form.Label>Part No</Form.Label>
                                            {partNoField}
                                        </Col>
                                        <Col md={2} sm={12} className="planning-form-field">
                                            <Form.Label>JO Qty</Form.Label>
                                            <input className="form-control" type="number" style={planningStyle} onFocus={ev => ev.target.select()} onChange={ev => {
                                                const synced = this.syncDerivedScheduleFields({
                                                    jsQuantity: ev.target.value,
                                                });
                                                this.setState({
                                                    jsQuantity: ev.target.value,
                                                    ...synced,
                                                });
                                                this.getBom(this.state.masterID);
                                            }} value={jsQuantity} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Product And Customer</div>
                                    <Row>
                                        <Col md={12} className="planning-form-field">
                                            <Form.Label>Part Description</Form.Label>
                                            <input type="text" className="form-control" style={readOnlyPlanningStyle} readOnly value={partDesc} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>No Cavity</Form.Label>
                                            <input type="number" className="form-control" style={planningStyle} readOnly value={cavityNo} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Part Weight</Form.Label>
                                            <input type="number" className="form-control" style={planningStyle} readOnly value={partWeight} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>P.R. Weight</Form.Label>
                                            <input type="number" className="form-control" style={planningStyle} readOnly value={partRunnerWeight} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Customer</Form.Label>
                                            <input type="text" className="form-control" style={readOnlyPlanningStyle} readOnly value={customer} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Customer PO</Form.Label>
                                            <input type="text" className="form-control" style={planningStyle} onChange={ev => { this.setState({ po: ev.target.value }) }} value={po} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Production Setup</div>
                                    <Row>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Process</Form.Label>
                                            <input type="text" className="form-control" style={planningStyle} readOnly value={allProcess} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Machine</Form.Label>
                                            <input type="text" className="form-control" style={planningStyle} onChange={ev => { this.setState({ machineNo: ev.target.value }) }} value={machineNo} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Line</Form.Label>
                                            <input type="text" className="form-control" style={planningStyle} onChange={ev => { this.setState({ lineNo: ev.target.value }) }} value={lineNo} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling No</Form.Label>
                                            {toolingNoField}
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling System</Form.Label>
                                            <input type="text" className="form-control" style={readOnlyPlanningStyle} readOnly value={mouldType} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling Life Cycle</Form.Label>
                                            <input type="number" className="form-control" min="0" style={planningStyle} readOnly value={mouldLifeBalance} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling Status</Form.Label>
                                            <input type="text" className="form-control" style={planningStyle} readOnly value={{ 0: 'OK', 1: 'NG', 2: 'Under Repair', 3: 'End of Life' }[this.state.toolingCondition] ?? '-'} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Machine Tonnage</Form.Label>
                                            <input type="number" className="form-control" style={planningStyle} readOnly value={machineTonnage} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Material Batch No</Form.Label>
                                            <input type="text" className="form-control" style={planningStyle} onChange={ev => { this.setState({ materialBatchNo: ev.target.value }) }} value={this.state.materialBatchNo} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Progress And Risk</div>
                                    <Row>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Time required to complete by Operation Hours (Hrs)</Form.Label>
                                            <input className="form-control" style={planningStyle} type="number" readOnly value={completeTime} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Remaining Time (Hrs)</Form.Label>
                                            <input type="number" className="form-control" min="0" style={planningStyle} readOnly value={remainingTime} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Risk Class</Form.Label>
                                            <FormControl readOnly as="select" placeholder="select"
                                                value={riskClass} onChange={(e) => this.setState({ riskClass: e.target.value })}>
                                                <option value="select">select</option>
                                                <option key={1} value={1}>Low</option>
                                                <option key={2} value={2}>Medium</option>
                                                <option key={3} value={3}>High</option>
                                            </FormControl>
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Manpower</Form.Label>
                                            <input type="number" className="form-control" style={planningStyle} onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ manpower: this.safeNumber(ev.target.value, 0) }) }} value={manpower === null || manpower === undefined || Number.isNaN(Number(manpower)) ? 0 : manpower} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Total Actual Cum Output</Form.Label>
                                            <input type="number" className="form-control" min="0" style={planningStyle} readOnly value={total_output} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Total Reject</Form.Label>
                                            <input type="number" className="form-control" min="0" style={planningStyle} readOnly value={total_reject} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Total Loss</Form.Label>
                                            <input type="number" className="form-control" min="0" style={planningStyle} readOnly value={total_loss} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Notes</div>
                                    <Row>
                                        <Col md={12} className="planning-form-field">
                                            <Form.Label>Remark</Form.Label>
                                            <textarea className="form-control planning-remark-field" onChange={ev => { this.setState({ remark: ev.target.value }) }} value={remark} />
                                        </Col>
                                    </Row>
                                </section>
                            </Form>
                        </div> :
                            <div>
                                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                                    <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                        <Col sm={1}><Form.Label>No</Form.Label></Col>
                                        <Col sm={1}><FormControl readOnly value={id} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                        <Col sm={1}><Form.Label>Customer</Form.Label></Col>
                                        <Col sm={5}><FormControl readOnly value={customer} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                        <Col sm={1}><Form.Label>Part No</Form.Label></Col>
                                        <Col sm={3}><FormControl readOnly value={partNo} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                        <Col sm={2}><Form.Label>Part Description</Form.Label></Col>
                                        <Col sm={7}><FormControl readOnly value={partDesc} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                        <Col sm={1}><Form.Label>JO Quantity</Form.Label></Col>
                                        <Col sm={2}><FormControl readOnly value={jsQuantity} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                    </FormGroup>

                                </div>
                                <div ref={el => (this.componentRef = el)}>
                                    <DataTable
                                        columns={[
                                            { name: 'No', selector: row => row.no, sortable: true, width: '5%' },
                                            { name: 'Material', selector: row => row.material, sortable: true, width: '10%' },
                                            { name: 'Material Description', selector: row => row.materialDesc, sortable: true, width: '15%' },
                                            { name: 'Color', selector: row => row.color, sortable: true, width: '10%' },
                                            { name: 'Code', selector: row => row.code, sortable: true, width: '5%' },
                                            { name: 'Usage', selector: row => row.usage, sortable: true, width: '5%' },
                                            { name: 'UoM', selector: row => row.uom, sortable: true, width: '5%' },
                                            { name: 'Per', selector: row => row.per, sortable: true, width: '5%' },
                                            { name: 'Where Use', selector: row => row.where_use, sortable: true, width: '10%' },
                                            { name: 'Source', selector: row => row.source, sortable: true, width: '10%' },
                                            { name: 'Category', selector: row => row.category, sortable: true, width: '10%' },
                                            { name: 'Supplier', selector: row => row.supplier, sortable: true, width: '10%' },
                                            { name: 'Total', selector: row => row.total, sortable: true, width: '10%' }
                                        ]}
                                        data={this.state.boms || []}
                                        highlightOnHover
                                        striped
                                    />
                                </div>
                            </div>}
                    </Modal.Body>
                    {this.state.pickingMode == false ? <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        {isPlanner(JSON.parse(localStorage.getItem('user'))) && newMode && (<Button variant="primary" onClick={handleCreate}>
                            Create
                        </Button>)}
                        {/* only planner(role=3) can edit */}
                        {isPlanner(JSON.parse(localStorage.getItem('user'))) && !newMode && (<Button variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>)}
                    </Modal.Footer> : ''
                    }
                </Modal>
            </div>

        );

    }

    prevClick = (schedulerData) => {
        schedulerData.prev();
        this.setState({
            selectedDate: schedulerData.startDate
        })
        this.loadData(schedulerData.startDate);
    }

    nextClick = (schedulerData) => {
        schedulerData.next();
        this.setState({
            selectedDate: schedulerData.startDate
        })
        this.loadData(schedulerData.startDate);
    }

    onViewChange = (schedulerData, view) => {
        schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
        schedulerData.config.customCellWidth = view.viewType === ViewType.Custom ? 30 : 80;
        this.loadData(schedulerData.startDate);
    }

    onSelectDate = (schedulerData, date) => {
        schedulerData.setDate(moment(date).format('YYYY-MM-DD'));
        this.setState({
            selectedDate: moment(date).format('YYYY-MM-DD')
        })
        this.loadData(moment(date).format('YYYY-MM-DD'));
    }

    eventClicked = (schedulerData, event) => {
        this.setState({ loadingEventDetails: true });
        fetch(`${config.apiUrl}/getJobsheet?jobID=${event.jobID}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);

                    return data;
                });
            })
            .then(job => {
                if (job) {
                    job = Object.assign(job, { modalShow: true, newMode: false, id: event.id });
                    this.getBom(job.masterID);
                    return fetch(`${config.apiUrl}/getOneMasterData?id=${job.masterID}`, requestOptions)
                        .then((response) => {
                            return response.text().then(text => {
                                const data = text && JSON.parse(text);

                                return data;
                            });
                        })
                        .then(data => {
                            job = Object.assign(job, event);
                            job = Object.assign(job, data);
                            job = Object.assign(job, {
                                jobID: event.jobID,
                                masterID: job.masterID,
                                color: event.bgColor.toUpperCase()
                            });

                            // Use local variables to avoid async setState race conditions
                            const opHrs = job.operationHours || 24;
                            const jsQuantity = job.jsQuantity || 0;
                            const cycleTime = data.cycleTime || 0;
                            const jobStart = job.start;
                            const newCompleteTime = this.calcCompleteTime(jsQuantity, cycleTime, opHrs);
                            const normalizedStart = formatPlanningStartDate(jobStart, true, opHrs);
                            const newEnd = this.calcEndDate(normalizedStart, newCompleteTime, opHrs);

                            // Single consolidated setState with all values
                            this.setState({
                                ...job,
                                start: normalizedStart,
                                operationHours: opHrs,
                                includeMasterJobNo: !!(job.masterJobNo && job.masterJobNo.length > 0),
                                completeTime: newCompleteTime,
                                remainingTime: this.calcRemainingTime(jsQuantity, job.total_output || 0, cycleTime, opHrs),
                                end: newEnd,
                                allProcess: data.process || '',
                                loadingEventDetails: false
                            }, () => {
                                this.fetchAndApplyToolingData(job.toolingID + '', job.total_output || 0);
                            });

                            // Fetch latest total qty to update remaining time with live data
                            if (job.jobNo && job.partNo) {
                                this._currentJobNo = job.jobNo;
                                fetch(`${config.apiUrl}/getCurrentTotalQty?partNo=${encodeURIComponent(job.partNo || '')}&jobNo=${encodeURIComponent(job.jobNo || '')}`, requestOptions)
                                    .then((response) => {
                                        return response.text().then(text => {
                                            const data = text && JSON.parse(text);
                                            return data;
                                        });
                                    })
                                    .then(result => {
                                        if (result && result[0] && result[0].total_output != null) {
                                            const synced = this.syncDerivedScheduleFields({
                                                jsQuantity,
                                                total_output: result[0].total_output,
                                                cycleTime,
                                                operationHours: opHrs,
                                                start: this.state.start,
                                            });
                                            this.setState({
                                                total_output: result[0].total_output,
                                                total_reject: result[0].total_reject,
                                                total_loss: result[0].total_loss,
                                                remainingTime: synced.remainingTime,
                                                completeTime: synced.completeTime,
                                                end: synced.end,
                                            }, () => {
                                                this.fetchAndApplyToolingData(job.toolingID + '', result[0].total_output);
                                            });
                                        }
                                    });
                            }
                        });
                }
                this.setState({ loadingEventDetails: false });
                return null;
            })
            .catch(error => {
                console.error('Error loading planning event details:', error);
                this.setState({ loadingEventDetails: false });
            });

    };

    ops1 = (schedulerData, event) => {
        alert(`You just executed ops1 to event: {id: ${event.id}, title: ${event.title}}`);
    };

    ops2 = (schedulerData, event) => {
        alert(`You just executed ops2 to event: {id: ${event.id}, title: ${event.title}}`);
    };

    newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!isPlanner(user))
            return alert(`Only planner id allowed to create planning.`);

        // Generate auto jobNo if accountId is not 2
        const accountId = JSON.parse(localStorage.getItem('user')).accountId;
        const autoJobNo = accountId !== 2 ? this.generateAutoJobNo() : '';
        const normalizedSchedule = this.normalizeDraggedSchedule(start, end);

        // Combine state reset and modal show in one setState call to ensure modal shows
        this.setState({
            ...this.baseState,
            list: this.state.list,
            jobnolist: this.state.jobnolist,
            toolings: this.state.toolings,
            modalShow: true,
            newMode: true,
            schedulerData,
            slotId,
            slotName,
            start: normalizedSchedule.start,
            end: normalizedSchedule.end,
            type,
            item,
            jobNo: autoJobNo,
            masterJobNo: '',
            includeMasterJobNo: false
        });

    }

    updateEventStart = (schedulerData, event, newStart) => {
        const eventId = event.oldId || event.id;
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }

        if (confirm(`Do you want to adjust the start of the event? {eventId: ${eventId}, eventTitle: ${event.title}, newStart: ${newStart}}`)) {
            fetch(`${config.apiUrl}/updatePlanning`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    start: newStart,
                    id: eventId
                })
            })
                .then((response) => {
                    return response.json().then(data => {
                        if (response.status === 200 && !data.error) {
                            this.loadData();
                            window.alert('Update Successfully.');
                            this.setState({ modalShow: false });
                        } else {
                            window.alert('Error updating planning: ' + (data.error || 'Unknown error'));
                        }
                    });
                })
                .catch(error => {
                    console.error('Error updating planning:', error);
                    window.alert('Error updating planning: ' + error.message);
                });
        }
        this.setState({
            viewModel: schedulerData
        })
    }

    updateEventEnd = (schedulerData, event, newEnd) => {
        const eventId = event.oldId || event.id;
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }

        if (confirm(`Do you want to adjust the end of the event? {eventId: ${eventId}, eventTitle: ${event.title}, newEnd: ${newEnd}}`)) {
            schedulerData.updateEventEnd(event, newEnd);
        }
        fetch(`${config.apiUrl}/updatePlanning`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                end: newEnd,
                id: eventId
            })
        })
            .then((response) => {
                return response.json().then(data => {
                    if (response.status === 200 && !data.error) {
                        this.loadData();
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                    } else {
                        window.alert('Error updating planning: ' + (data.error || 'Unknown error'));
                    }
                });
            })
            .catch(error => {
                console.error('Error updating planning:', error);
                window.alert('Error updating planning: ' + error.message);
            });
        this.setState({
            viewModel: schedulerData
        })
    }

    movingEvent = (schedulerData, event, slotId, slotName, newStart, newEnd) => {

    }

    moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
        const eventId = event.oldId || event.id;
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }

        if (confirm(`Do you want to move the event? {eventId: ${eventId}, eventTitle: ${event.title}, newSlotId: ${slotId}, newSlotName: ${slotName}, newStart: ${start}, newEnd: ${end}`)) {
            const normalizedSchedule = this.normalizeDraggedSchedule(start, end);
            start = normalizedSchedule.start;
            end = normalizedSchedule.end;
            schedulerData.moveEvent(event, slotId, slotName, start, end);
            fetch(`${config.apiUrl}/updatePlanning`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    start,
                    end,
                    id: eventId
                })
            })
                .then((response) => {
                    return response.json().then(data => {
                        if (response.status === 200 && !data.error) {
                            this.loadData();
                            window.alert('Update Successfully.');
                            this.setState({ modalShow: false });
                        } else {
                            window.alert('Error updating planning: ' + (data.error || 'Unknown error'));
                        }
                    });
                })
                .catch(error => {
                    console.error('Error updating planning:', error);
                    window.alert('Error updating planning: ' + error.message);
                });
            this.setState({
                viewModel: schedulerData
            })
        }
    }

    removeEvent = (event) => {
        if (confirm(`Do you want to delete the event? {eventId: ${event.oldId}, eventTitle: ${event.title}, start: ${event.start}, end: ${event.end}`)) {
            fetch(`${config.apiUrl}/deletePlanning?id=${event.oldId}`, requestOptions)
                .then(response => {
                    if (response.status == 200) {
                        window.alert('Deleted Successfully.');
                        this.loadData();
                    }
                    this.setState({
                        viewModel: schedulerData
                    })
                });
        }
    }

    getCustomDate = (schedulerData, num, date = undefined) => {
        const { viewType } = schedulerData;
        let selectDate = schedulerData.startDate;

        if (date != undefined)
            selectDate = date;
        // startDate = moment().format('YYYY-MM-DD');

        let startDate = num === 0 ? selectDate :
            moment(selectDate).add(1 * num, 'days').format(DATE_FORMAT),
            endDate = moment(startDate).add(1, 'days').format(DATE_FORMAT),
            cellUnit = CellUnit.Hour;
        let monday = moment(selectDate).startOf('week').format(DATE_FORMAT);
        startDate = moment(startDate).format(DATE_FORMAT);
        endDate = moment(startDate).add(2, 'weeks').format(DATE_FORMAT);
        cellUnit = CellUnit.Day;

        return {
            startDate,
            endDate,
            cellUnit
        };
    }

    isNonWorkingTime = (schedulerData, time) => {
        // SchedulerData may call this during construction, before this.state exists.
        const opHrs = (this.state && this.state.operationHours) || 24;
        if (schedulerData.cellUnit === CellUnit.Hour) {
            return !isPlanningWorkingMoment(moment(time), opHrs);
        }

        // Day columns use start-of-day; fade entire Saturday and Sunday columns.
        const dayOfWeek = moment(time).day();
        return dayOfWeek === 0 || dayOfWeek === 6;
    }

    /** Weekend fade on all rows (including Manpower), which overrides groupOnlySlotColor. */
    getPlanningWeekendCellBgColor = (schedulerData, slotId, header) => {
        if (header.nonWorkingTime) {
            return schedulerData.config.nonWorkingTimeBodyBgColor;
        }
        return undefined;
    }

    toggleExpandFunc = (schedulerData, slotId) => {
        schedulerData.toggleExpandStatus(slotId);
        this.setState({
            viewModel: schedulerData
        });
    }

    eventItemTemplateResolver = (
        schedulerData,
        event,
        bgColor,
        isStart,
        isEnd,
        mustAddCssClass,
        mustBeHeight,
        agendaMaxEventWidth
    ) => {
        const titleText = schedulerData.behaviors.getEventTextFunc(schedulerData, event);

        // Check if this is a Manpower row event (resourceId '2')
        const isManpowerEvent = event.resourceId === '2';

        const style = {
            backgroundColor: isManpowerEvent ? 'transparent' : bgColor,
            height: mustBeHeight,
            borderRadius: isManpowerEvent ? 0 : 14,
            cursor: isManpowerEvent ? 'default' : 'pointer',
            position: 'relative',
            userSelect: 'none',
            color: isManpowerEvent ? '#000000' : undefined
        };

        return (
            <div
                key={event.id}
                className={mustAddCssClass}
                style={style}
                title={titleText}
                onMouseUp={(e) => {
                    // Don't handle clicks for manpower events
                    if (isManpowerEvent) return;

                    setTimeout(() => {
                        if (e.button !== 0) return;

                        // Prevent click-after-drag
                        if (schedulerData._isDragging) return;

                        this.eventClicked(schedulerData, event);
                    }, 0);
                }}
            >
                <span style={{
                    marginLeft: 10,
                    lineHeight: `${mustBeHeight}px`,
                    pointerEvents: 'none',
                    fontWeight: isManpowerEvent ? 'bold' : undefined
                }}>
                    {titleText}
                </span>

                {!isManpowerEvent && (
                    <div
                        title="Delete"
                        style={{
                            position: 'absolute',
                            right: 5,
                            top: 2,
                            cursor: 'pointer'
                        }}
                        onMouseUp={(e) => {
                            e.stopPropagation();
                            this.removeEvent(event);
                        }}
                    >
                        ×
                    </div>
                )}
            </div>
        );
    };

}
export default withDragDropContext(Planning);
